<template>
  <div class="top">
    <body
      id="particles-js"
      style="margin-top: 0%; background-color: #000"
    ></body>
    <div class="home-btn d-none d-sm-block pt-0"></div>
    <div class="account-pages my-0 pt-0">
      <div class="container pt-5">
        <h1 class="text-success"></h1>
        <slot />
      </div>
    </div>
  </div>
</template>

<script>
import "particles.js";

export default {
  components: {},
  data() {
    return {
      theme: "",
      checkbox: false,
    };
  },
  mounted() {
    this.theme = localStorage.getItem("theme");
    require("particles.js");
    this.$nextTick(() => {
      this.initParticles();
    });
  },
  methods: {
    initParticles() {
      if (this.theme !== "dark") {
        window.particlesJS("particles-js", {
          particles: {
            number: { value: 6, density: { enable: true, value_area: 800 } },
            color: { value: "#bf151c" },
            shape: {
              type: "polygon",
              stroke: { width: 0, color: "#000" },
              polygon: { nb_sides: 6 },
              image: { src: "img/github.svg", width: 100, height: 100 },
            },
            opacity: {
              value: 0.3,
              random: true,
              anim: { enable: false, speed: 1, opacity_min: 0.1, sync: false },
            },
            size: {
              value: 160,
              random: false,
              anim: { enable: true, speed: 10, size_min: 40, sync: false },
            },
            line_linked: {
              enable: false,
              distance: 200,
              color: "#bf151c",
              opacity: 1,
              width: 2,
            },
            move: {
              enable: true,
              speed: 8,
              direction: "none",
              random: false,
              straight: false,
              out_mode: "out",
              bounce: false,
              attract: { enable: false, rotateX: 600, rotateY: 1200 },
            },
          },
          interactivity: {
            detect_on: "canvas",
            events: {
              onhover: { enable: false, mode: "grab" },
              onclick: { enable: false, mode: "push" },
              resize: true,
            },
            modes: {
              grab: { distance: 400, line_linked: { opacity: 1 } },
              bubble: {
                distance: 400,
                size: 40,
                duration: 2,
                opacity: 8,
                speed: 3,
              },
              repulse: { distance: 200, duration: 0.4 },
              push: { particles_nb: 4 },
              remove: { particles_nb: 2 },
            },
          },
          retina_detect: true,
        });
      } else {
        window.particlesJS("particles-js", {
          particles: {
            number: { value: 6, density: { enable: true, value_area: 800 } },
            color: { value: "#bf151c" },
            shape: {
              type: "polygon",
              stroke: { width: 0, color: "#000" },
              polygon: { nb_sides: 6 },
              image: { src: "img/github.svg", width: 100, height: 100 },
            },
            opacity: {
              value: 0.3,
              random: true,
              anim: { enable: false, speed: 1, opacity_min: 0.1, sync: false },
            },
            size: {
              value: 160,
              random: false,
              anim: { enable: true, speed: 10, size_min: 40, sync: false },
            },
            line_linked: {
              enable: false,
              distance: 200,
              color: "#bf151c",
              opacity: 1,
              width: 2,
            },
            move: {
              enable: true,
              speed: 8,
              direction: "none",
              random: false,
              straight: false,
              out_mode: "out",
              bounce: false,
              attract: { enable: false, rotateX: 600, rotateY: 1200 },
            },
          },
          interactivity: {
            detect_on: "canvas",
            events: {
              onhover: { enable: false, mode: "grab" },
              onclick: { enable: false, mode: "push" },
              resize: true,
            },
            modes: {
              grab: { distance: 400, line_linked: { opacity: 1 } },
              bubble: {
                distance: 400,
                size: 40,
                duration: 2,
                opacity: 8,
                speed: 3,
              },
              repulse: { distance: 200, duration: 0.4 },
              push: { particles_nb: 4 },
              remove: { particles_nb: 2 },
            },
          },
          retina_detect: true,
        });
      }
    },
    toggleCheckbox() {
      if (this.theme == "light") {
        location.reload();
        this.theme = "dark";
        localStorage.setItem("theme", "dark");
        this.checkbox = !this.checkbox;
        this.$emit("setCheckboxVal", this.checkbox);
      } else if (this.theme == "dark") {
        location.reload();
        this.theme = "";
        localStorage.setItem("theme", "");
        this.checkbox = !this.checkbox;
        this.$emit("setCheckboxVal", this.checkbox);
      } else {
        this.theme = "dark";
        localStorage.setItem("theme", "dark");
        this.checkbox = !this.checkbox;
        this.$emit("setCheckboxVal", this.checkbox);
        location.reload();
      }
    },
  },
};
</script>

<style scoped>
#particles-js {
  position: absolute;
  width: 100%;
  height: 100%;
  overflow: hidden;
  /* top:0% */
}
body {
  padding: 0;
  margin: 0;
}
.top {
  background-color: #28896e;
  bottom: 0;
  top: 0;
}

.togle {
  margin-bottom: -0%;
}

.switch {
  position: relative;
  display: inline-block;
  width: 60px;
  height: 34px;
}

.switch input {
  display: none;
}

.slider {
  position: absolute;
  cursor: pointer;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  background-color: #0a3c68;
  -webkit-transition: 0.4s;
  transition: 0.4s;
}

.slider:before {
  position: absolute;
  content: "";
  height: 26px;
  width: 26px;
  left: 4px;
  bottom: 4px;
  background-color: #07335a;
  -webkit-transition: 0.4s;
  transition: 0.4s;
}

input:checked + .slider {
  background-color: #292f3d;
}

input:focus + .slider {
  box-shadow: 0 0 1px #ccc;
}

input:checked + .slider:before {
  -webkit-transform: translateX(26px);
  -ms-transform: translateX(26px);
  transform: translateX(26px);
}

.slider.round {
  border-radius: 34px;
}

.slider.round:before {
  border-radius: 50%;
}
</style>
